import { useInterviewContext } from "../../InterviewContext";
import { useTranslation } from "react-i18next";
import RatingItem from "../GlobalClassification/RatingItemPreview";
import "../../../../pages/Interview/Interview.scss";
import "../../../styles/forms.scss";
import DisabledTextArea from "../../../../components/DisabledTextArea";
import { useEffect, useState } from "react";

const GlobalClassificationTabPreview = ({ interview }) => {
  const { t } = useTranslation();
  const [globalRating, setGlobalRating] = useState(0);
  useEffect(() => {
    calculateGlobalRating(interview.skills);
  }, [interview.skills]);
  const calculateGlobalRating = (skills) => {
    if (skills.length > 0) {
      let total = 0;
      skills.forEach((skill) => {
        total += skill.rating * skill.weight;
      });
      let decimal = total % 1;
      if (decimal >= 0.049 && decimal < 0.06) {
        total += 0.01;
      }
      setGlobalRating(total.toFixed(1));
    }
  };
  return (
    <div className="global-classification">
      <div className="col-6">
        <h1>{t("Personal Skills and Competences")}</h1>

        {interview.skills.map((skill) => (
          <div className="row ranking" key={skill.id}>
            <div className="col">{t(skill.personalSkill)}</div>
            <div className="col text-end ">({skill.rating})</div>
            <div className="col aling-center">
              <RatingItem skill={skill} />
            </div>
          </div>
        ))}
        <div
          style={{ borderBottom: "1px solid #bebebe", borderWidth: "medium" }}
        />
        <div className="row mt-2 align-items-center">
          <div className="col">
            <strong style={{ marginRight: "12px", fontWeight: 600 }}>
              {t("Global Rating")}
            </strong>{" "}
          </div>
          <div className="col text-end">{globalRating}</div>
          <div className="col">
            <RatingItem skill={{ rating: globalRating }} />
          </div>
        </div>
      </div>
      <div className="form-group mt-2">
        <label htmlFor="notes" className="form-label">
          {t("Global notes")}
        </label>
        <DisabledTextArea id="notes" name="notes" value={interview.notes} />
      </div>
    </div>
  );
};
export default GlobalClassificationTabPreview;
